import React from "react";
import { Box, Image, Heading } from "@chakra-ui/react";

import BenefitBg from "../../assets/Landing/Benefitsbg.png";
import OgticLogo from "../../assets/Landing/OgticLogo.svg";
// import MicrosoftLogo from "../../assets/Landing/MicrosoftLogo.svg"
// import HuaweiLogo from "../../assets/Landing/HuaweiLogo.svg"
// import AWSLogo from "../../assets/Landing/AWSLogo.svg"
// import InapiLogo from '../../assets/Landing/InapiLogo.svg';
// import CaidLogo from '../../assets/Landing/CaidLogo.svg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Partnerships() {
  const partners = [OgticLogo /*, MicrosoftLogo, HuaweiLogo, AWSLogo, InapiLogo, CaidLogo*/];

  return (
    <Box
      bgImage={`url(${BenefitBg})`}
      bgSize="cover"
      pt="80px"
      pb="80px"
      id="Partnerships"
    >
      <Heading
        color="var(--600, #0D1216)"
        textAlign="center"
        fontFamily="Quicksand"
        fontSize="40px"
        fontWeight="700"
        lineHeight="48px"
        mb="40px"
      >
        Partnerships That Empower TEA
      </Heading>
      <div className="flex flex-col lg:flex-row items-center justify-center w-full gap-5">
        {partners.map((logo, index) => (
          <div className="pt-10 lg:pt-0" key={index}>
            <Image src={logo} alt={`Logo ${index}`} />
          </div>
        ))}
      </div>
    </Box>
  );
}

export default Partnerships;
